<template>
    <div id="property" class="header-gap bo">
      <div class="sub-banner">
        <div class="container">
          <h1 v-html="$t('property.banner-title')"></h1>
          <p v-html="$t('property.banner-desc')"></p>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="column">
            <h2>{{$t("property.doo-property")}}</h2>
            <p><i></i> {{$t("property.doo-property-desc")}}</p>
            <a href="https://property.doo.com/" target="_blank" v-t="'property.learn-more'"></a>
          </div>
          <div>
            <img src="https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/business_overview/property.png" />
          </div>
        </div>
      </div>
      <BOContactUs bocontent="property"/>
    </div>
    <Modals />
  </template>
    
  <script setup>
    import "../less/style.css"
    import Modals from '@/components/Modals/ModalMain.vue'
    import BOContactUs from '@/components/BOContactUs.vue'

    import { useHead } from '@unhead/vue'
    import { useI18n } from 'vue-i18n'
    import { computed, onMounted } from 'vue'
    import { decodeHtml } from '@/utils'

    const { t } = useI18n()

    useHead({
      title: computed(() => decodeHtml(t('seo.property.title'))),
      meta: [
        { name: 'description', content: computed(() => t('seo.property.description')) },
        { name: 'keywords', content: computed(() => t('seo.property.keywords')) },
      ],
    })

    onMounted(() => {
      if (typeof document !== 'undefined')
        document.dispatchEvent(new Event('prerender-ready'))
    })
  
  </script>
  
  <style lang="less">
    @import '../less/mediaQuery.less';
  
    #property {
      .sub-banner {
        background:url('https://cdn.dootech.io/doo/business_overview/banner_realEstate.png') no-repeat center top;
        @media @mobile-screen {
          background:url('https://cdn.dootech.io/doo/business_overview/banner_realEstate_mb.png') no-repeat center top;
        }
        .container {
          @media only screen and (max-width:1500px) and (min-width:835px) {
            max-width: 40%;
            margin: 0;
          }
        }
      }
      @media only screen and (max-width:1400px) and (min-width:951px) {
        .container {
          padding:0 32px;
        }
      }
      
    }
  </style>
